import Header from 'components/ModalFaqs/Sections/Header/styled';

export default Header;
